import DetaillierterUberblick from "./slides/DetailierterUeberblick";
import Profitieren from "./slides/Profitieren";

export default function StrategischePartner() {
  return [
    <Profitieren key="profitieren" />,
    <DetaillierterUberblick key="detaillierter-ueberblick" />,
  ];
}
